import React, { useState } from 'react';
import axios from 'axios';
import { authBaseUrl } from '../../config/runtime';
import '../../styles/Auth.css';

const Register = ({ onToggle }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post(`${authBaseUrl}/register`, {
      company_name: companyName,
      name,
      email,
      phone,
      password,
      plan: 'starter'
    })
      .then(response => {
        const createdCode = response?.data?.company_code;
        setSuccessMessage(
          createdCode
            ? `Cadastro concluído. Código interno da empresa: ${createdCode}. Faça login com seu e-mail.`
            : 'Cadastro concluído. Faça login com seu e-mail.'
        );
        setErrorMessage('');
        setPassword('');
      })
      .catch(error => {
        const msg = error?.response?.data?.message || 'Erro ao registrar. Tente novamente.';
        setErrorMessage(msg);
        setSuccessMessage('');
      });
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Registro</h2>
      <div className="auth-form-logo">
        <img src="/logo-nextdevelop.jpeg" alt="Next Develop" />
      </div>
      {successMessage && <div className="success-message">{successMessage}</div>}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <div>
        <label>Empresa (nome)</label>
        <input 
          type="text" 
          value={companyName} 
          onChange={(e) => setCompanyName(e.target.value)} 
        />
      </div>
      <div>
        <label>Nome completo</label>
        <input 
          type="text" 
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div>
        <label>E-mail</label>
        <input 
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="seuemail@empresa.com"
        />
      </div>
      <div>
        <label>Telefone</label>
        <input 
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="(00) 00000-0000"
        />
      </div>
      <div>
        <label>Senha</label>
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
        />
      </div>
      <button type="submit">Registrar</button>
      <p>Já tem uma conta? <button type="button" onClick={onToggle} className="link-button">Faça login</button></p>
    </form>
  );
};

export default Register;
